import React from 'react';
import {
  OutlinedInput,
  OutlinedInputProps,
  Typography,
} from '@material-ui/core';
import { useStyles } from './styles';

interface IMaterialInputProps extends OutlinedInputProps {
  label: string;
  width?: string | number;
}

const MaterialInput: React.FC<IMaterialInputProps> = ({
  label,
  width,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container} style={{ width }}>
      <div className={classes.labelContainer}>
        <Typography variant="subtitle1" className={classes.label}>
          {label}
        </Typography>
      </div>
      <OutlinedInput className={classes.input} {...rest} />
    </div>
  );
};

export default MaterialInput;
